import * as React from "react"

import LeftPane from './LeftPane';
import RightPane from './RightPane';
import Foot from './Foot';
import MobilePage  from './MobilePage';

import './css/main.css';
import 'bootstrap/dist/css/bootstrap.css';

import bg1 from './images/aleksandr-popov-ez4pqCpEfuI-unsplash.jpg';
import bg2 from './images/aleksandr-popov-GmLfS_S43gA-unsplash.jpg';
import bg3 from './images/alexey-turenkov-LZp01Y9g-zo-unsplash.jpg';
import bg4 from './images/ben-neale-zpxKdH_xNSI-unsplash.jpg';
import bg5 from './images/diane-picchiottino-FBPzc81dwDw-unsplash.jpg';
import bg6 from './images/irina-iriser-rhRlzHJcv5w-unsplash.jpg';
import bg7 from './images/mitchell-kavan-yoegh5378Cw-unsplash.jpg';
import bg8 from './images/sandro-katalina-k1bO_VTiZSs-unsplash.jpg';
import bg9 from './images/possessed-photography-2DFjuTTnt2Y-unsplash.jpg';
import bg10 from './images/random-thinking-fX4lA-CIAwk-unsplash.jpg';

// Put them in an array for easy random access
const backgrounds = [bg1, bg2, bg3, bg4, bg5, bg6, bg7, bg8, bg9, bg10];

function App() {
 // Pick one randomly
 const randomBackground = backgrounds[Math.floor(Math.random() * backgrounds.length)];
 return (
   <>
     <div className="d-none d-lg-block">
       <main className="d-flex vh-100 vw-100 justify-content-center align-items-center" 
         style={{
           backgroundImage: `url(${randomBackground})`,
           backgroundSize: 'cover',
           backgroundPosition: 'center',
           height: '100vh',
           width: '100vw'
         }}>
         <div className="container">
           <div className="row">
             <div className="col-lg-6 leftpane rounded-start">
               <LeftPane />
             </div>
             <div className="col-lg-6 rightpane rounded-end">
               <RightPane />
             </div>
           </div>
           <Foot />
         </div>
       </main>
     </div>
     <div className="d-block d-lg-none mobile">
       <MobilePage />
     </div>
   </>
 )
}

export default App;
